import React from 'react';
import CallDashboardPatientInfoForm from 'components/molecules/call-dashboard/forms/patient-info';

interface IProps {
  patientGuid: string;
  isRpmCall?: boolean;
  isOnCall: boolean;
}

const CallDashboardPatientInfoTab: React.FC<IProps> = (props) => {
  const { patientGuid, isRpmCall, isOnCall } = props;

  return (
    <div>
      <CallDashboardPatientInfoForm
        patientGuid={patientGuid}
        isRpmCall={isRpmCall}
        isOnCall={isOnCall}
      />
    </div>
  );
};

export default CallDashboardPatientInfoTab;
